import { Injectable } from '@angular/core';
import { first, switchMap, takeUntil, tap } from 'rxjs/operators';
import { firstValueFrom, of, Subject } from 'rxjs';
import { DialogService } from '@shared/dialog/services/dialog.service';
import { GlobalInformationModalComponent } from '@shared/components/global-information-modal/global-information-modal.component';
import { MatDialogRef } from '@angular/material/dialog';
import { PolicyApiService } from '@modules/private/admin/popups-manager/pages/policy-popup/services/policy.api.service';
import { selectUser } from '@core/modules/user/features/user.slice';
import { Store } from '@ngrx/store';

@Injectable({
  providedIn: 'root'
})
export class GlobalInformationModalService {
  private destroySubject = new Subject<void>();
  isOpened: boolean = false;

  constructor(
    private dialogService: DialogService,
    private apiService: PolicyApiService,
    private store: Store
  ) {}

  open(translation: string = '', callback?: Function) {
    if (this.isOpened) {
      return;
    }
    this.isOpened = true;
    return this.dialogService
      .openDialog({
        title: 'dialog.information.title',
        message: [translation],
        component: GlobalInformationModalComponent,
        panelClass: 'ind-dialog',
        closeButton: false,
        disableClose: true,
        actions: [
          {
            label: 'dialog.information.button.accept',
            handler: (dialogRef: MatDialogRef<GlobalInformationModalComponent>) => {},
            close: true
          }
        ]
      })
      .pipe(
        takeUntil(this.destroySubject),
        switchMap(() => {
          const acceptNewPolicy$ = this.store.select(selectUser).pipe(
            first(),
            switchMap((user) => {
              return this.apiService.acceptNewPolicy(user!);
            })
          );

          return callback ? acceptNewPolicy$ : of(firstValueFrom(acceptNewPolicy$));
        }),
        tap(async () => {
          this.isOpened = false;
          callback && (await callback());
        })
      )
      .subscribe();
  }
}
